import React, { createContext, useContext, useState, useCallback } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('kgreen_user')); } catch { return null; }
  });
  const [token, setToken] = useState(() => sessionStorage.getItem('kgreen_token') || null);

  const login = useCallback((userData, tok, auditId) => {
    setUser(userData);
    setToken(tok);
    sessionStorage.setItem('kgreen_user', JSON.stringify(userData));
    sessionStorage.setItem('kgreen_token', tok);
    if (auditId) sessionStorage.setItem('kgreen_audit_id', String(auditId));
  }, []);

  const logout = useCallback(() => {
    const tok = sessionStorage.getItem('kgreen_token');
    const auditId = sessionStorage.getItem('kgreen_audit_id');
    if (tok && auditId) {
      fetch('/api/auth/logout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tok}` },
        body: JSON.stringify({ audit_id: auditId }),
      }).catch(() => {});
    }
    setUser(null);
    setToken(null);
    sessionStorage.removeItem('kgreen_user');
    sessionStorage.removeItem('kgreen_token');
    sessionStorage.removeItem('kgreen_audit_id');
  }, []);

  const role = user?.role;
  return (
    <AuthContext.Provider value={{
      user, token, login, logout,
      isAdmin:           role === 'admin' || role === 'super_admin',
      isManager:         role === 'manager',
      isCustomerManager: role === 'customer_manager',
      // isAgent: true for agent, manager, admin, and super_admin
      isAgent: role === 'agent' || role === 'manager' || role === 'admin' || role === 'super_admin',
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
